import { render, staticRenderFns } from "./show.vue?vue&type=template&id=c643b5d6&scoped=true&"
import script from "./show.vue?vue&type=script&lang=js&"
export * from "./show.vue?vue&type=script&lang=js&"
import style0 from "./show.vue?vue&type=style&index=0&id=c643b5d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c643b5d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c643b5d6')) {
      api.createRecord('c643b5d6', component.options)
    } else {
      api.reload('c643b5d6', component.options)
    }
    module.hot.accept("./show.vue?vue&type=template&id=c643b5d6&scoped=true&", function () {
      api.rerender('c643b5d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/show.vue"
export default component.exports